import { IRVehicleDetails } from "api/interfaces/garage-apis";
import { ISetVehicleDetailsAction } from "../interfaces/utils.interface";
export function setVehicleDetails(data: Promise<object | IRVehicleDetails | []>): ISetVehicleDetailsAction {
  return {
    type: "SET_VEHICLE_DETAILS",
    data,
  };
}
